import React from 'react';
import ReactDOM from 'react-dom';
import AudioPlayer from './AudioPlayer';


ReactDOM.render(
  <React.StrictMode>
    <AudioPlayer />
  </React.StrictMode>,
  document.getElementById('root')
);

